import React from 'react';
import { useActionLogExplorer } from '../hooks/use-action-log-explorer.js';
import ActionLogExplorerPageView from './action-log-explorer-page-view.jsx';

function ActionLogExplorerPageContainer() {
  const state = useActionLogExplorer();

  return <ActionLogExplorerPageView {...state} />;
}

export default ActionLogExplorerPageContainer;
